import { Flex, Pane, Text } from '@leverege/ui-elements'
import React from 'react'

import useHistoricalCountsJanked from '../hooks/useHistoricalCountsJanked'

export default function HistoricalCounts( props ) {
  const { label, icon } = props

  const { yesterday, thisWeek, thisMonth } = useHistoricalCountsJanked( props )

  return (
    <Pane variant="card" layout="flex:rowSpaceBetween">
      <Text icon={icon}>{label}</Text>
      <Flex variant="rowSpaceAround" style={{ flexGrow : 1 }}>
        <Flex variant="colM">
          <Text variant="caption">Yesterday</Text>
          <Text variant="title">{yesterday}</Text>
        </Flex>
        <Flex variant="colM">
          <Text variant="caption">This Week (To Date)</Text>
          <Text variant="title">{thisWeek}</Text>
        </Flex>
        <Flex variant="colM">
          <Text variant="caption">This Month (To Date)</Text>
          <Text variant="title">{thisMonth}</Text>
        </Flex>
      </Flex>
    </Pane>
  )
}
